import React, { useEffect, useRef } from 'react';
import resumePDF from '../../assets/documents/resume.pdf'


const Header = () => {

  const headerRef = useRef(null)
  const menuRef = useRef(null);

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.classList.toggle('show__menu');
    }
  };

  const stickyHeaderFunc = () => {
    window.addEventListener('scroll', () => {
      if(document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        headerRef.current.classList.add('sticky__header')
      }
      else {
        headerRef.current.classList.remove('sticky__header')
      }
    })
  }
  useEffect(() => {
    stickyHeaderFunc()
    return window.removeEventListener('scroll', stickyHeaderFunc)
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
  
    const targetAttr = e.currentTarget.getAttribute('href');
    const targetElement = document.getElementById(targetAttr.substring(1));
  
    if (targetElement) {
      const location = targetElement.offsetTop;
      window.scrollTo({
        top: location - 80,
        left: 0,
        behavior: 'smooth',
      });
    }
  };  

  
  return (
    <header ref={headerRef} 
    className='w-full h-[80px] leading-[80px] flex items-center'>
      <div className='container'>
          <div className='flex items-center justify-between'>
            <div className='flex items-center gap-[10px] pt-2'>
              <span className='w-[35px] h-[35px] bg-primaryColor text-white text-[18px] font-[500] rounded-full flex items-center justify-center cursor-pointer'>Ds</span>
              <div className='leading-[20px]'>
              <h2 className='text-xl text-smallTextColor font-[700]'>Dennis</h2>
              <p className='text-smallTextColor text-[15px] font-[500]'>personal</p>
              </div>
            </div>
          <div className="menu" ref={menuRef} onClick={toggleMenu}>
          <ul className='flex items-center gap-10 text-smallTextColor font-[500] cursor-pointer'>
            <li>
              <a onClick={handleClick} href="#about" alt='about'>About</a>
            </li>
            <li>
              <a onClick={handleClick} href="#services" alt='experience'>Services</a>
            </li>
            <li>
              <a onClick={handleClick} href="#portfolio" alt='work'>Portfolio</a>
            </li>
            <li>
              <a onClick={handleClick} href="#testimonial" alt="testimony">Testimonials</a>
            </li>
            <li>
              <a onClick={handleClick} href="#contact" alt="contact">Contact</a>
            </li>
          </ul>

          </div>
          <div className="flex flex-items-center gap-4">
            <button className='flex items-center gap-2 text-white font-[600] border border-solid py-2 px-4 rounded-none border-white max-h-[35px] hover:bg-primaryColor hover:text-wite hover:font-[600] ease-in duration-300 ' >
            <i className="ri-file-list-line"></i>
              <a className="resume-button" href={resumePDF} target="_blank" rel="noopener noreferrer">
                Resume
              </a>
            </button>
            <span onClick={toggleMenu} className='md:hidden text-2xl text-smallTextColor'><i className="ri-menu-5-line"></i></span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header